import { GoalsSlideBase } from './GoalsSlideBase';

const GoalsSlide = () => <GoalsSlideBase renderCardBlur={() => null} />;

export default GoalsSlide;
